import { render, staticRenderFns } from "./api-tokens.vue?vue&type=template&id=93625f84&scoped=true"
import script from "./api-tokens.vue?vue&type=script&lang=js"
export * from "./api-tokens.vue?vue&type=script&lang=js"
import style0 from "./api-tokens.vue?vue&type=style&index=0&id=93625f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93625f84",
  null
  
)

export default component.exports